import React, { useState } from "react";
import { ReactComponent as ArrowBack } from "../../../../assets/images/icons/prevArrow.svg";
import { ReactComponent as ArrowForward } from "../../../../assets/images/icons/forwardArrow.svg";

import "./PeopleCarousel.css";

export const CarouselItem = ({ children, width }) => {
  return (
    <div className="people-carousel-item" style={{ width: width }}>
      {children}
    </div>
  );
};

const Carousel = ({ children, className }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const updateIndex = (newIndex) => {
    if (newIndex < 0) {
      newIndex = React.Children.count(children) - 1;
    } else if (newIndex >= React.Children.count(children)) {
      newIndex = 0;
    }

    setActiveIndex(newIndex);
  };

  return (
    <div className={`${className}`}>
      <div
        className="people-inner"
        style={{ transform: `translateX(-${activeIndex * 100}%)` }}
      >
        {React.Children.map(children, (child, index) => {
          return React.cloneElement(child, { width: "100%" });
        })}
      </div>
      <div className="people-indicators flex items-center">
        {React.Children.map(children, (child, index) => {
          return (
            <div
              className={`transform transition-all duration-200 ease-linear ${
                index === activeIndex
                  ? "bg-blue-950 w-6 h-1.5 rounded-xl"
                  : "h-1.5 w-3 border border-blue-950 mx-1 rounded-xl"
              }`}
            ></div>
          );
        })}

        <button
          onClick={() => {
            updateIndex(activeIndex - 1);
          }}
          className="hover:bg-blue-950 hover:fill-white rounded-full flex justify-center items-center w-9 h-9 transform transition-all duration-200 ease-linear"
        >
          <ArrowBack className="w-9" />
        </button>

        <button
          onClick={() => {
            updateIndex(activeIndex + 1);
          }}
          className="hover:bg-blue-950 hover:fill-white rounded-full flex justify-center items-center w-9 h-9 transform transition-all duration-200 ease-linear"
        >
          <ArrowForward className="w-9" />
        </button>
      </div>
    </div>
  );
};

export default Carousel;
